import classNames from "classnames";
import map from "lodash/map";
import noop from "lodash/noop";
import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { Step } from "@Types/cart";
import "./style.scss";

interface Props {
  activeStep: Step;
  onClick: (step: Step) => void;
  steps: Step[];
}

const CartBreadcrumb: FunctionComponent<Props> = ({ activeStep, onClick, steps }) => {
  const intl = useIntl();

  return (
    <ul className="CartBreadcrumb">
      {map(steps, (step) => {
        const isActive = step === activeStep;

        return (
          <li
            className={classNames("CartBreadcrumb-step", {
              "CartBreadcrumb-step--active": isActive,
            })}
            key={step}
            onClick={isActive || step === "overview" ? noop : () => onClick(step)}
          >
            {intl.formatMessage({
              id: `cheerz_CartBreadcrumb_step__${step}`,
            })}
          </li>
        );
      })}
    </ul>
  );
};

export default CartBreadcrumb;
